<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <nav
    class="sidebar-fixed sidebar sidebar-offcanvas"
    id="sidebar"
    :style="
      isSidebarOpen ? { right: 'unset', position: 'fixed' } : { right: '-100%' }
    "
    v-if="$can('browse', 'Administration')"
  >
    <admin-sidebar></admin-sidebar>
  </nav>
  <nav
    class="sidebar-fixed sidebar sidebar-offcanvas"
    id="sidebar"
    :style="
      isSidebarOpen ? { right: 'unset', position: 'fixed' } : { right: '-100%' }
    "
    v-else
  >
    <marchand-sidebar></marchand-sidebar>
  </nav>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "../../router/eventBus";
export default {
  name: "sidebar",
  data() {
    return {
      isSidebarOpen: false,
      profileView: false,
      switch1: false,
      switch2: true,
      marchandexiste: false,
      user: JSON.parse(localStorage.getItem("user")),
      allmarchands: [],
      checked:
        this.$store.getters.marchand &&
        this.$store.getters.marchand._env === "live"
          ? true
          : false,
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen; // Toggle sidebar visibility
    },
  },
  beforeDestroy() {
    EventBus.$off("toggle-sidebar"); // Remove the event listener when component is destroyed
  },
  computed: {
    currentPage() {
      return this.$route.name;
    },
    ...mapState("marchands/", ["marchandu"]),
  },
  mounted() {
    if (this.$store.getters.marchand) {
      this.marchandexiste = true;
      this.$store.dispatch("marchands/getMarchandUser");
      this.$store.dispatch("marchands/getMarchandByUser").then((response) => {
        this.allmarchands =
          response && response.data && response.data.marchandu
            ? response.data.marchandu
            : {};
      });
    }
    EventBus.$on("toggle-sidebar", this.toggleSidebar);
  },
};
</script>

<style>
#sidebar {
  position: fixed !important;
}
@media (min-width: 1024px) {
  #sidebar {
    left: 0 !important;
  }
}

/* Sidebar should be closed on mobile by default */
@media (max-width: 1023px) {
  #sidebar {
    right: -100%;
  }
}
</style>
